import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      viewBox: "0 0 30 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsx("mask", {
        id: "6y5f6s5te__mask0_9235_42343",
        style: {
          maskType: "alpha"
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "30",
        height: "30",
        children: _jsx("path", {
          d: "M0.5 15C0.5 6.99187 6.99187 0.5 15 0.5C23.0081 0.5 29.5 6.99187 29.5 15C29.5 23.0081 23.0081 29.5 15 29.5C6.99187 29.5 0.5 23.0081 0.5 15Z",
          fill: "#C4C4C4",
          stroke: "#152361"
        })
      }), _jsxs("g", {
        mask: "url(#6y5f6s5te__mask0_9235_42343)",
        children: [_jsx("rect", {
          x: "-4.75391",
          y: "0.25",
          width: "41.5",
          height: "29.5",
          rx: "1.75",
          fill: "white",
          stroke: "#F5F5F5",
          strokeWidth: "0.5"
        }), _jsx("mask", {
          id: "tcpsxty42__mask1_9235_42343",
          style: {
            maskType: "alpha"
          },
          maskUnits: "userSpaceOnUse",
          x: "-6",
          y: "0",
          width: "43",
          height: "30",
          children: _jsx("rect", {
            x: "-4.75391",
            y: "0.25",
            width: "41.5",
            height: "29.5",
            rx: "1.75",
            fill: "white",
            stroke: "white",
            strokeWidth: "0.5"
          })
        }), _jsxs("g", {
          mask: "url(#tcpsxty42__mask1_9235_42343)",
          children: [_jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M-5.00391 10H36.9961V0H-5.00391V10Z",
            fill: "#CA2B39"
          }), _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M-5.00391 29.9999H36.9961V19.9999H-5.00391V29.9999Z",
            fill: "#2C56A2"
          })]
        }), _jsx("path", {
          d: "M-5.00391 0V-1H-6.00391V0H-5.00391ZM36.9961 0H37.9961V-1H36.9961V0ZM36.9961 30V31H37.9961V30H36.9961ZM-5.00391 30H-6.00391V31H-5.00391V30ZM-5.00391 1H36.9961V-1H-5.00391V1ZM35.9961 0V30H37.9961V0H35.9961ZM36.9961 29H-5.00391V31H36.9961V29ZM-4.00391 30V0H-6.00391V30H-4.00391Z",
          fill: "#152361"
        }), _jsx("path", {
          d: "M1 15C1 7.26801 7.26801 1 15 1C22.732 1 29 7.26801 29 15C29 22.732 22.732 29 15 29C7.26801 29 1 22.732 1 15Z",
          stroke: "#152361",
          strokeWidth: "2"
        })]
      })]
    }))
  });
};
export default Component;
